import NotCheckedInEmployees from "./NotCheckedInEmployees";
import NotClockedInTeachers from "./NotClockedInTeachers";

interface StaffSummaryProps {
    refreshTrigger: number;
}

const StaffSummary: React.FC<StaffSummaryProps> = ({
    refreshTrigger
}) => {
    return (
        <div className="staff-tab">
            <NotClockedInTeachers refreshTrigger={refreshTrigger} />
            <NotCheckedInEmployees refreshTrigger={refreshTrigger} />
        </div>
    )
}

export default StaffSummary;